// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 708 ? "aa923549" : chunkId) + "." + {"68":"a2b4e1feb1ef7873","394":"21558831d81a909f","708":"22eb9fe77d73a4c4"}[chunkId] + ".js";
};